import Select from 'react-select';
import { theme } from '../constants';

/** Single-property dropdown that drives the whole page. */
function PropertySelect({ options, value, onChange, placeholder = 'Select a property', isDisabled = false }) {
  const selected = options.find((option) => option.value === value) || null;

  return (
    <Select
      options={options}
      value={selected}
      onChange={(option) => onChange(option ? option.value : null)}
      placeholder={placeholder}
      isClearable
      isDisabled={isDisabled}
      noOptionsMessage={() => 'No properties found'}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{
        menuPortal: (styleBase) => ({ ...styleBase, zIndex: 9999 }),
        control: (styleBase, state) => ({
          ...styleBase,
          borderRadius: 9,
          minHeight: 40,
          fontSize: 13.5,
          fontFamily: theme.font,
          borderColor: state.isFocused ? theme.accent : theme.border,
          boxShadow: state.isFocused ? `0 0 0 3px ${theme.accentSoft}` : 'none',
          '&:hover': { borderColor: theme.accent },
        }),
        placeholder: (styleBase) => ({ ...styleBase, color: theme.textFaint, fontSize: 13 }),
        singleValue: (styleBase) => ({ ...styleBase, color: theme.text, fontWeight: 600 }),
        menu: (styleBase) => ({ ...styleBase, borderRadius: 10, overflow: 'hidden', fontFamily: theme.font }),
        menuList: (styleBase) => ({ ...styleBase, maxHeight: 260 }),
        option: (styleBase, state) => ({
          ...styleBase,
          fontSize: 13,
          fontFamily: theme.font,
          cursor: 'pointer',
          fontWeight: state.isSelected ? 700 : 500,
          backgroundColor: state.isSelected ? theme.accentSoft : state.isFocused ? '#f5f7ff' : theme.surface,
          color: state.isSelected ? theme.accent : '#333',
        }),
      }}
    />
  );
}

export default PropertySelect;
